import { createProviderWithCustomFetchData } from './create-data-provider';
import { fetchJsonWithNetworkRetries } from '../utils/fetch';
import { ExperienceMark } from '../utils/experience-tracker';
export const APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT = '/gateway/api/app-switcher/api/available-products';
export const appSwitcherBffAvailableProductsFetch = (url = APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT) => async () => {
  let init;
  if (url === APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT) {
    init = {
      headers: {
        'Atl-App-Switcher-Private-API': 'true'
      }
    };
  }
  const response = await fetchJsonWithNetworkRetries(url, {
    intervalsMS: [50, 200, 1000]
  }, init);
  return response;
};
export const createAppSwitcherBffAvailableProductsProvider = (url = APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT) => {
  return createProviderWithCustomFetchData('appSwitcherBffAvailableProducts', ExperienceMark.API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, appSwitcherBffAvailableProductsFetch(url));
};